<div *ngIf="template === templates.Objkt" class="flex-column direct-auth-login-alt objkt">
  <app-objkt-signin (abort)="abort()" (login)="login($event)"></app-objkt-signin>
</div>
<div *ngIf="template !== templates.Objkt" class="flex-column direct-auth-login-alt" [class.manutd]="template === 'manutd'">
  <div class="flex-row header">
    <img (click)="abort()" class="abort" src="../../../assets/img/x-alt.svg">
    <img *ngIf="loginConfig.showBackButton" (click)="back()" class="back" src="../../../assets/img/back-arrow.svg">
  </div>
  <h1>{{ template === 'manutd' ? 'CHOOSE SOCIAL PROVIDER' : 'Choose Sign In Type' }}</h1>
  <div class="flex-row-wrap login-options" *ngIf="torusService && torusService.verifierMapKeys">
    <ng-container *ngFor="let key of loginOptions; let idx = index">
      <div *ngIf="loginConfig.buttonsVertically === true || (loginConfig.wideButtons && loginConfig.wideButtons[idx] === true); else narrow" class="flex-row option wide" [class.facebook]="key === 'facebook'" [class.twitter]="key === 'twitter'" [class.reddit]="key === 'reddit'"
        (click)="login(key)">
        <img [src]="getImgSrc(key)" width="24" /><span>Sign in with {{ getDisplayKey(key) |
          titlecase }}</span>
      </div>
      <ng-template #narrow>
        <div class="flex-row option narrow"
        (click)="login(key)">
        <img [src]="'../../../../assets/img/torus-login/' + getDisplayKey(key) + '-color.svg'" width="24" />
      </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="footer">
    <span>Powered by</span><img class="logo" src="../../../../assets/img/header-logo-grey.svg">
  </div>
</div>